/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>超级外链列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
<!--    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.qr_title" placeholder="输入活码标题"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form> -->
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="service_ame" label="链接服务名称" width="360">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="24">
              <p>{{scope.row.service_ame}}</p>
              <div style="margin-top: 1rem;">{{scope.row.url_crea_time}}</div>
            </el-col>
          </el-row>
        </template>
        </el-table-column>
      <el-table-column label="状态" align="center" min-width="100">
        <template slot-scope="scope">
          <div>{{scope.row.status == 1 ? '正常' : '异常'}}</div>
        </template>
      </el-table-column>
      <el-table-column label="跳转页数据" min-width="120">
        <template slot-scope="scope">
           <div>总共：{{scope.row.visit_num}}</div>
           <div>当日：{{scope.row.today_visit_num}}</div>
        </template>
      </el-table-column>
      <el-table-column label="落地页数据" min-width="120">
        <template slot-scope="scope">
           <div>总共：{{scope.row.arrive_num}}</div>
           <div>当日：{{scope.row.today_arrive_num}}</div>
        </template>
      </el-table-column>
      <el-table-column label="长按数据" min-width="120">
        <template slot-scope="scope">
           <div>总共：{{scope.row.long_press_num}}</div>
           <div>当日：{{scope.row.today_long_press_num}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-row :gutter="20">
            <el-col :span="24"><el-button size="mini" type="primary" icon="el-icon-s-grid" @click="gotourl(scope.$index, scope.row,'超级子码')">子码管理</el-button></el-col></el-row>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import vueQr  from 'vue-qr'
import { qrList, qrSave, qrDelete, getYuming } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import base64 from 'base-64'
export default {
  data() {
    return {
      rukouurl: '', //入口网址
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加',
      editForm: {
        id: '',
        qr_title: '',
        remark: ''
      },
      // rules表单验证
      rules: {
        qr_title: [
          { required: true, message: '请输入活码标题', trigger: 'blur' }
        ]
      },
      formInline: {
        pageNum: 1,
        pageSize: 10,
        groupId: 506
      },
      // 删除部门
      seletedata: {
        ids: ''
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination, vueQr
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    window.myData = this

    let user = localStorage.getItem('userInfo')
    let userObj = JSON.parse(user)
    let groupid = userObj.groupid
    console.log(groupid)
    if(groupid > 0){
      this.gettoken(groupid);
    }

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    gettoken(groupid){
      let _that = this
      let config = {
         method: 'post',
         url: _that.$linkUrl + '/open/api/getAccessToken?appKey=6d7b3ac7b22e4d58&secretKey=6d7b3ac7b22e4d58a96de98253',
         headers: {
            'User-Agent': 'Apifox/1.0.0 (https://apifox.com)'
         }
      };

      _that.$axios(config)
      .then(function (response) {
          let config2 = {
             method: 'post',
             url: _that.$linkUrl +  '/open/api/groupLink?access_token=' + response.data.data.access_token + '&pageNum=1&pageSize=15&groupId='+groupid+'&keyword=',
             headers: {
                'User-Agent': 'Apifox/1.0.0 (https://apifox.com)'
             }
          };

          _that.$axios(config2)
          .then(function (response2) {
             _that.listData = response2.data.content
          })
          .catch(function (error) {
             console.log(error);
          });
      })
      .catch(function (error) {
         console.log(error);
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //跳转页面
    gotourl(index, row, urlname) {
      this.$router.push({ name: urlname, params: {id: row.service_id, type_id: row.type_id} })
    }
  },
  //计算属性
  computed:{

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.czbutton {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/weike/linklist.vue